//
// Copyright (c) 2011-2024 by Curalate, Inc.
//
export const BAZAARVOICE_CONTACT_SUPPORT_URL =
  'https://support.bazaarvoice.com/s/contactsupport';

export const IMPACT_APP_URL = 'https://app.impact.com/';
